import styles from './Table.module.scss';
import cn from 'classnames';
import { TableRowContext } from './TableRowContext';

interface TableRowProps {
  children: React.ReactNode;
  style?: string;
  onClick?: () => void;
  /** Если задан href, middle-click открывает запись в новой вкладке,
   *  а все ячейки строки рендерят нативный <a> — это даёт правому клику
   *  браузерное меню "Открыть в новой вкладке". */
  href?: string;
}

export const TableRow = ({ children, onClick, style, href }: TableRowProps) => {
  const handleAuxClick = (e: React.MouseEvent<HTMLTableRowElement>) => {
    // button 1 — колесо мыши / middle click
    if (href && e.button === 1) {
      e.preventDefault();
      window.open(href, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <TableRowContext.Provider value={{ href }}>
      <tr
        onClick={onClick}
        onAuxClick={handleAuxClick}
        className={cn(
          styles.tableRow,
          onClick ? styles.tableRowClickable : null,
          style
        )}
      >
        {children}
      </tr>
    </TableRowContext.Provider>
  );
};
